module.exports = __webpack_public_path__ + "img/manual.a916479e.png";